interface DataViewHeaderProps {
    header: string[]
}

const DataViewHeader: React.FC<DataViewHeaderProps> = (props: DataViewHeaderProps) => {
    return(
        <tr>
            {props.header.map((value, index) => {
                return (<th key={index}>{value}</th>)
            })}
        </tr>
    )
}

export default DataViewHeader;